// extracted by mini-css-extract-plugin
export default {"Header":"styles_Header__00sa5","Title":"styles_Title__DAzll","ServiceName":"styles_ServiceName__zuMBc"};